<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     首页
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="welcome-index">

    <div class="left">

      <event-todo class="mb-md"></event-todo>

      <resource-card class="mb-md" />

      <ei-card class="mb-md" />

      <el-card class="mb-md" shadow="never" body-style="">
        <el-row :gutter="20">
          <el-col :span="12">
            <rms-recent-visit-equip />
          </el-col>
          <el-col :span="12">
            <dev-recent-update />
          </el-col>
        </el-row>
      </el-card>
      

    </div>

    <div class="right">
      <fnc-new-notice class="mb-md" />

      <FeeOverview class="mb-md"></FeeOverview>

      <wechat-card v-if="aiot_version == 0 || (wechat.status > 0 && wechat.status < 4) " class="mb-md" />

      <asst-card />

    </div>

  </div>
</template>

<script>
export default {
  components: {
    FncNewNotice: () => import('@/views/fnc/components/FncNewNotice'),
    ResourceCard: () => import('./components/ResourceCard'),
    EiCard: () => import('./components/EiCard'),
    RmsRecentVisitEquip: () => import('@/views/rms/components/RmsRecentVisitEquip'),
    DevRecentUpdate: () => import('@/views/dev/components/DevRecentUpdate'),
    WechatCard: () => import('./components/WechatCard'),
    WxappCard: () => import('./components/WxappCard'),
    FeeOverview: () => import('./components/FeeOverview'),
    AsstCard: () => import('./components/AsstCard'),
    EventTodo: () => import('./components/EventTodo'),
  },

  data() {
    return {
    }
  },

  computed: {
    aiot_version() {
      return this.$store.state.godStore.aiot_version
    },

    wechat() {
      return Object.assign({}, this.$store.state.godStore.wechat);
    }
  },

  methods: {
  }

}
</script>

<style lang="scss" scoped>
.welcome-index {
  position: relative;

  >.left {
    position: absolute;
    top: 20px;
    left: 0px;
    right: 380px;
  }

  >.right {
    position: absolute;
    top: 20px;
    right: 0px;
    width: 360px;

    /deep/ .carousel.el-carousel {
      .el-carousel__container {
        height: 210px;
      }
    }
  }
}
</style>
